<template lang="pug">
b-container(fluid)
    search
</template>

<script>
import Search from '@/components/Search'
export default {
    name: 'Home',
    components: { Search },
    data() {
        return {}
    }
}
</script>
